// services/MentorRegistrationForm.services.js
import { baseUrl } from '../../services/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const MentorRegistrationFormSlice = createApi({
  reducerPath: 'MentorRegistrationForm',

  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl, // Adjust based on your API base URL
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['MentorRegistrationForm'],
  endpoints: (builder) => ({
    registerMentor: builder.mutation({
      query: (formData) => ({
        url: 'mentor-registration/',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['MentorRegistrationForm'],
    }),

    editMentor: builder.mutation({
      query: ({ id, formData }) => ({
        url: `mentor-registration/${id}/?edit=true`,
        method: 'PUT', // or PATCH depending on your API
        body: formData,
      }),
      invalidatesTags: ['MentorRegistrationForm'],
    }),
     signatureUpload: builder.mutation({
      query: ({ id, formData, params }) => ({
        url: `mentor-registration/${id}/?${params}`,
        method: 'PATCH', // or PATCH depending on your API
        body: formData,
      }),
      invalidatesTags: ['MentorRegistrationForm'],
    }),
    bgSignatureUpload: builder.mutation({
      query: ({ id, formData, params }) => ({
        url: `mentor-registration/${id}/?${params}`,
        method: 'PATCH', // or PATCH depending on your API
        body: formData,
      }),
      invalidatesTags: ['MentorRegistrationForm'],
    }),
    getMentorRegistrationFormDetails: builder.query({
      query: (id) => ({
        url: `mentor-registration/${id}/`,
        method: 'GET', 
      }),
      providesTags: ['MentorRegistrationForm'],
    }),

    getMentorRegistrationFormStatus: builder.query({
      query: (id) => `onboarding-status/${id}/`,
      providesTags: ['MentorRegistrationForm'],
    }),
  }),
});

export const {
  useRegisterMentorMutation,
  useSignatureUploadMutation,
  useGetMentorRegistrationFormStatusQuery,
  useGetMentorRegistrationFormDetailsQuery,
  useEditMentorMutation,
  useBgSignatureUploadMutation,
} = MentorRegistrationFormSlice;

export default MentorRegistrationFormSlice;
